module.exports = __webpack_public_path__ + "2cabeb0a2be6809adf2eff2cfdd7f949.png";